import _ from "lodash";

import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import {withApollo} from "react-apollo";
import Select from 'react-select';

//material-ui imports
import GridContainer from "../../../components/Grid/GridContainer";
import ItemGrid from "../../../components/Grid/ItemGrid";
import Button from "../../../components/CustomButtons/Button";
import CustomInput from "../../../components/CustomInput/CustomInput";

import Checkbox from 'material-ui/Checkbox';
import { withStyles } from 'material-ui/styles';
import styles from '../styles';
import {pinAssign} from '../graph';
import { getProjectGroups } from '../../users/graph';
import Loading from '../../etc/Loading';

import Radio from 'material-ui/Radio/Radio';

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

class PinAssignmentModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matchPos: 'any',
      matchValue: true,
      value:null,
      count:0,
      usernameStartsWith: '',
      loading: false,
      form:{
        options:[
          null
        ],
      },
      selected:[],
      allUsers:false,
      addType: "user",
      groupOptions: [],
      selectedGroup: null, 
      selectedGroupMemberCount: null,
      alert: null
    };
    this.orig_count = null;
    /* function binds */
    this.onChange = this.onChange.bind(this);
    this.validate = this.validate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.confirmation = this.confirmation.bind(this)
  }
  
  componentDidMount(){
    let values = [];
    
    this.props.getUsersByPid.refetch().then((result) =>{
      if (_.isEmpty(result.data))
        return;

      result.data.project.users.edges.map((entry,index)=>{
        if (entry.node.active == true){
          values.push({
            value:entry.node.uid,
            label:entry.node.username
          })
        }
      })
    });
    this.setState({
      loading: true
    });
    this.props.getPinCount.refetch({
      pid:this.props.projectId
    }).then((result) => {
      
      this.orig_count = this.props.getPinCount.getPinCount.count;
      this.setState({
        count:this.orig_count,
        options: values,
        loading: false
      });
    });
  }
  
  onChange(value) {
    this.setState({
      selected:value,
      value:value
    });
  }

  handleChange(name,event) {
    const value = event.target.value;
    let members_count = 0;

    this.setState({
      [name]: value,
    });

    if (name === "addType" && value === "group"){
      this.setState({
        allUsers: false
      })
      
      this.props.client.query({
        query: getProjectGroups,
        variables: {
          pid: this.props.projectId
        },
        fetchPolicy: "network-only",
        errorPolicy: "all"
      }).then((data) => {
        let options = [];
        const groups = data.data.getProjectGroups;
        if(_.isEmpty(groups)){
          alert("No existing groups found");
          this.setState({
            addType: "user"
          });
        }
        else{
          groups.map((group, index) => {
            members_count = group.usersGroup.edges.length;
            options.push({label: `${group.groupId}-${group.name} (${members_count})`, value: group.groupId, members: members_count})
          });

          this.setState({
            groupOptions: options,
            selectedGroup: options[0].value,
            selectedGroupMemberCount:  options[0].members
          });
        }
      }).catch((error) => {
        console.log("error");
      })
    } else {
      this.setState({
          selectedGroupMemberCount: null
        });

    }
  };

  handleSelectChange = (data) => {
    this.setState({
      selectedGroup: data.value,
      selectedGroupMemberCount: data.members
    });
  }

  handleCheckboxChange(name,event){
    this.setState({
      [name]: event.target.checked,
    });
  }

  validate(){
    if (_.isEmpty(this.state.selected) && this.state.allUsers === false && this.state.usernameStartsWith === '' 
        && this.state.addType === "user"){
      alert("No users are selected");
      return false
    }
    else if(this.state.count > this.orig_count){
      alert("Pins must not exceed count")
      return false
    }
    return true
  }

  handleSubmit(){
    let valid = this.validate(this);

    if (valid){
      let formData = {};
      formData["pincount"] = this.state.count;
      formData["pid"] = this.props.projectId;
      formData["addType"] = this.state.addType;

      if (this.state.addType === "user"){
        formData["userids"] = this.state.selected
        formData["usernameStartsWith"] = this.state.usernameStartsWith;
        formData["allUsers"] = this.state.allUsers;
      }
      else{
        formData["group_id"] = this.state.selectedGroup
      }
      
      
      this.props.assignPins({
        variables: {
          inputJson: JSON.stringify(formData)
        }
      }).then((result) => {
        const data = JSON.parse(result.data.assignPins.jsonObject);
        let message = data.message;
        this.props.assignPinModalClose(data.totalPin, data.totalUsers, "");

      }).
      catch((failed) => {
        let errorData = failed.graphQLErrors.map(x => x.message);
        alert(`Pin assign failed!\n${JSON.parse(errorData[0]).message}`);
      });
    }
  }

  hideAlert(){
    this.setState({
      alert: null
    })
  }

  confirmation(event){
    event.preventDefault()
    let users_selected;

    if (this.state.allUsers === true)
      users_selected = "ALL (FWP and PMs in this project)"
    else
      users_selected = (this.state.selectedGroupMemberCount != null) ? 
                              this.state.selectedGroupMemberCount : this.state.selected.length;
    
    this.setState({
      alert: <SweetAlert
          warning
          title="Assign Pins?"
          onConfirm={() => this.handleSubmit()}
          onCancel={() => this.hideAlert()}
          confirmBtnText="Yep!"
          cancelBtnText="Cancel"
          showCancel
        >
          You are about to assign {this.state.count} pins to {users_selected} user(s).
        </SweetAlert>
    })
  }

  onUsernameStartOnChange(event) {
    this.setState({usernameStartsWith: event.target.value});
  }

  render(){
    let text = 'Choose users';
    const { classes } = this.props;
    const { count, loading, usernameStartsWith, alert } = this.state;
    return (
      <SweetAlert
        title={this.props.projectName}
        onConfirm={() => this.props.assignPinModalClose("", "", "close")}
        onCancel={() => this.props.assignPinModalClose("", "", "close")}
        showConfirm={false}
        style={{"overflow":"visible !important","width":"30%","textAlign":"center"}}
      >
        {alert}
        { (loading) === false ?
        <GridContainer>
          { (count === 0) ? 
            <ItemGrid xs={12}>
              <h4>No Pins to assign for this Project</h4>
              <Button onClick={() => this.props.assignPinModalClose("", "", "close")}>
                Close
              </Button>
            </ItemGrid>

          :
          <ItemGrid xs={12}>
            <form onSubmit={this.confirmation}>
              <ItemGrid>
                <label>By User</label>
                <Radio
                  checked={this.state.addType === "user"}
                  onChange={this.handleChange.bind(this, "addType")}
                  value="user"
                  name="addType"
                  aria-label="By User"
                />
                <label>By Group</label>
                <Radio
                  checked={this.state.addType === "group"}
                  onChange={this.handleChange.bind(this, "addType")}
                  value="group"
                  name="addType"
                  aria-label="By Group"
                />
                </ItemGrid>
                { (this.state.addType === "user") ?
                <ItemGrid>
                  <Select
                    isSearchable
                    multi={true}
                    isSearchable
                    onChange={this.onChange}
                    options={this.state.options}
                    value={this.state.value}
                    placeholder={text}
                  />
                  <label>Usernames starting with: </label>
                  <CustomInput
                      id="name"
                      formControlProps={{
                        className: classes.textField2
                      }}
                      inputProps={{
                        onChange: this.onUsernameStartOnChange.bind(this),
                        value: usernameStartsWith
                      }}
                    />
                  <ItemGrid>
                    <label>All users</label>
                    <Checkbox 
                    color="primary"
                    onChange={this.handleCheckboxChange.bind(this,'allUsers')}></Checkbox>
                  </ItemGrid>
                </ItemGrid> 

                :
                <ItemGrid>
                    <Select 
                      name="selectedGroup"
                      onChange={this.handleSelectChange}
                      options={this.state.groupOptions}
                      placeholder="Select Group"
                      value={this.state.selectedGroup}
                      clearable={false}
                    />
                </ItemGrid>
                }
              <ItemGrid>
                <label>Pins to allocate</label>
                <CustomInput
                    id="name"
                    formControlProps={{
                      className: classes.textField
                    }}
                    inputProps={{
                      onChange: this.handleChange.bind(this, "count"),
                      value: count
                    }}
                  />
              </ItemGrid>

              <ItemGrid>
                <Button type="submit" variant="raised" color="primary" className={classes.button}>
                  Assign pins
                </Button>
              </ItemGrid>
            </form>
          </ItemGrid>
        }
        </GridContainer>
        : <Loading />}
      </SweetAlert>
    )
  }
}

export default withStyles(styles, sweetAlertStyle)((pinAssign)(withApollo(PinAssignmentModal)))


// WEBPACK FOOTER //
// ./src/views/pin/components/PinAssignModal.js